/**
 * @param {string[]} livewireEvents
 * @param {boolean} shouldLoadByMethod
 * @param {string[]} methods
 */
export default (
    livewireEvents,
    shouldLoadByMethod = true,
    methods = ['continue', 'previous', 'ourProducts', 'changeEvent'],
) => ({
    loading: false,

    init(){
        livewireEvents.forEach(event => {
            Livewire.on(event, () => {
                this.loading = true;
            });
        });

        Livewire.hook('message.sent', ({ updateQueue }) => {
            if(! this.shouldLoad(updateQueue)){
                return;
            }

            this.loading = true;
        });
    },

    shouldLoad(updateQueue){
        const filter = shouldLoadByMethod
            ? ({ type }) => type === 'callMethod'
            : ({ type, method }) => type === 'callMethod' && method === '$set';

        const condition = shouldLoadByMethod
            ? ({ method }) => methods.includes(method)
            : ({ payload }) => payload.params.includes('teamId');

        return updateQueue
            .filter(filter)
            .some(condition);
    },
});
